// Generated from packages/contracts/permissions.ts by scripts/generate-client.mjs; do not edit.
const RESOURCES = [
  "public",
  "account",
  "attention",
  "work",
  "projects",
  "conversations",
  "agents",
  "knowledge",
  "skills",
  "automations",
  "connections",
  "workspaces",
  "models",
  "members",
  // IAM-04/05: the team's identity provider, SCIM tokens and sign-in policy.
  "sso",
  "settings",
  "audit",
];
const ACTIONS = ["read", "write", "manage"];
const TEAM_ROLES = ["owner", "admin", "member", "viewer"];
const permission = (resource, action) => ({
  resource,
  action,
});
const all = ["read", "write", "manage"];
const use = ["read", "write"];
const read = ["read"];
const memberGrants = {
  public: read,
  account: use,
  // Everyone clears their own Needs you inbox (ATT-04).
  attention: use,
  work: use,
  projects: read,
  conversations: use,
  agents: use,
  knowledge: use,
  skills: read,
  models: read,
  // SET-04: everyone sees who is in their team (names, usernames, emails, roles).
  // Activity details, invites and every change stay with members:manage.
  members: read,
};
const ROLE_GRANTS = {
  owner: Object.fromEntries(RESOURCES.map((resource) => [resource, all])),
  admin: Object.fromEntries(RESOURCES.map((resource) => [resource, all])),
  member: memberGrants,
  // Viewers read what members read; their own account stays theirs to change.
  viewer: {
    ...Object.fromEntries(
      Object.keys(memberGrants).map((resource) => [resource, read]),
    ),
    account: use,
  },
};
const SCOPE_GRANTS = {
  "identity:read": [
    permission("account", "read"),
    permission("attention", "read"),
    permission("work", "read"),
  ],
  "agents:read": [permission("agents", "read"), permission("models", "read")],
  "agents:write": [permission("agents", "write")],
  "conversations:read": [
    permission("conversations", "read"),
    permission("attention", "read"),
    permission("models", "read"),
  ],
  "conversations:write": [permission("conversations", "write")],
  "audit:read": [permission("audit", "read")],
  "export:read": [permission("agents", "read")],
};
function can(role, resource, action) {
  if (resource === "public") return true;
  return ROLE_GRANTS[role]?.[resource]?.includes(action) ?? false;
}
function tokenCan(scopes, resource, action) {
  return scopes.some((scope) =>
    SCOPE_GRANTS[scope]?.some(
      (grant) => grant.resource === resource && grant.action === action,
    ),
  );
}
export {
  ACTIONS,
  RESOURCES,
  ROLE_GRANTS,
  SCOPE_GRANTS,
  TEAM_ROLES,
  can,
  permission,
  tokenCan,
};
